
import Vue from 'vue'

export default Vue.extend({
  name: 'Button',

  props: {
    loading: {
      type: Boolean as Prop<boolean>,
      default: false
    },

    block: {
      type: Boolean as Prop<boolean>,
      default: false
    }
  }
})
